module.exports = __webpack_public_path__ + "img/banner-one6.558d0fbb.png";